module.exports = __webpack_public_path__ + "images/icons/icon-refer-c2acc9c8.svg";